// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__A0EZV","notes":"Notes_notes__1YeHB","note":"Notes_note__1gSTH","markdown":"Notes_markdown__1KVU1"};